export const isFeatureEnabled = () => {
  return process.env.REACT_APP_ENABLE_FEATURE === 'true';
};
